import request from "../utils/request"

export function fetchMockUsers() {
  return request({
    url: "/admin/simulation/mock-users",
    method: "get"
  })
}

export function createMockUsers(data) {
  return request({
    url: "/admin/simulation/mock-users",
    method: "post",
    data
  })
}

export function deleteMockUser(id) {
  return request({
    url: `/admin/simulation/mock-users/${id}/delete`,
    method: "post"
  })
}

export function updateMockUser(id, data) {
  return request({
    url: `/admin/simulation/mock-users/${id}`,
    method: "post",
    data
  })
}

export function fetchSimulationPosts(params = {}) {
  return request({
    url: "/admin/simulation/posts",
    method: "get",
    params
  })
}

export function createSimulationPost(data) {
  return request({
    url: "/admin/simulation/posts",
    method: "post",
    data
  })
}

export function simulatePostLikes(postId, count) {
  return request({
    url: `/admin/simulation/posts/${postId}/likes`,
    method: "post",
    data: { count }
  })
}

export function simulatePostComment(postId, data) {
  return request({
    url: `/admin/simulation/posts/${postId}/comments`,
    method: "post",
    data
  })
}

export function resetSimulationData() {
  return request({
    url: "/admin/simulation/reset",
    method: "post"
  })
}
